import { H2RCheckbox, H2RHeading, H2RInput, H2RSelect } from "../../imports";
import ThemeSection from "./ThemeSection";
import {
	fontSizeOptions,
	leadingOptions,
	paddingOptions,
	marginOptions,
	transitionOptions,
	transitionDurationOptions,
	roundedOptions,
	borderOptions,
	borderSizeOptions,
	thicknessOptions,
	gradientOptions,
} from "../../imports";
import { findThemeLabel } from "./findThemeLabel";
import BorderSelect from "./BorderSelect";
import { useSelector } from "react-redux";

export default function GlobalStyles({ baseTheme, themeId, onUpdate }) {
	
	const fonts = useSelector(
		(state) => state.main.fonts || []
	);
	return (
		<>
			<H2RHeading type="h5">Global styles</H2RHeading>
			{/* <ThemeSection name="Font" icon="font">
			<H2RInput
						key={`${baseTheme.name}_font_family`}
						label="Font used on all graphics"
						colour="dark"
						value={baseTheme.font?.family}
						onChange={(change) => {
							onUpdate("font", "family", change);
						}}
						options={[
							...fonts?.map((font)=>{
								return {
									label: font,
									value: font
								}
							})
						]}
					/>
			</ThemeSection> */}
			<ThemeSection name="Large text" icon="h1">
				<H2RInput
						key={`${baseTheme.name}_h1_font`}
						label="Font"
						colour="dark"
						value={baseTheme.h1?.font || baseTheme.font?.family}
						onChange={(change) => {
							onUpdate("h1", "font", change);
						}}
						inputHasOptions={true}
						options={[
							...fonts?.map((font)=>{
								return {
									label: font,
									value: font
								}
							})
						]}
					/>
				<H2RInput
					key={`${baseTheme.name}_h1_colour`}
					label="Colour"
					colour="dark"
					colourPicker={true}
					value={baseTheme.h1?.colour}
					onChange={(change) => {
						onUpdate("h1", "colour", change);
					}}
				/>
				<H2RInput
					key={`${baseTheme.name}_h1_size`}
					type="range"
					label="Size"
					colour="dark"
					value={fontSizeOptions.findIndex((e, i) => {
						if (e.value === baseTheme.h1?.size) return i;
					})}
					labelValue={findThemeLabel(fontSizeOptions, baseTheme.h1?.size)}
					options={fontSizeOptions}
					max={fontSizeOptions.length - 1}
					onChange={(change) => {
						onUpdate("h1", "size", fontSizeOptions[change].value);
					}}
				/>
				<H2RInput
					key={`${baseTheme.name}_h1_leading`}
					type="range"
					label="Line height"
					colour="dark"
					value={leadingOptions.findIndex((e, i) => {
						if (e.value === baseTheme.h1?.leading) return i;
					})}
					labelValue={
						findThemeLabel(leadingOptions, baseTheme.h1?.leading) || "Auto"
					}
					options={leadingOptions}
					max={leadingOptions.length - 1}
					onChange={(change) => {
						onUpdate("h1", "leading", leadingOptions[change].value);
					}}
				/>
				<div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
					<H2RCheckbox
						key={`${baseTheme.name}_h1_bold`}
						randomId={`h1_bold`}
						checkboxLabel="Bold"
						checked={["true", true].includes(baseTheme.h1?.bold) ? true : false}
						onChange={(change) => {
							onUpdate("h1", "bold", change);
						}}
					/>
					<H2RCheckbox
						key={`${baseTheme.name}_h1_italic`}
						randomId={`h1_italic`}
						checkboxLabel="Italic"
						checked={
							[true, "true"].includes(baseTheme.h1?.italic) ? true : false
						}
						onChange={(change) => {
							onUpdate("h1", "italic", change);
						}}
					/>
					<H2RCheckbox
						key={`${baseTheme.name}_h1_underline`}
						randomId={`h1_underline`}
						checkboxLabel="Underline"
						checked={
							[true, "true"].includes(baseTheme.h1?.underline) ? true : false
						}
						onChange={(change) => {
							onUpdate("h1", "underline", change);
						}}
					/>
				</div>
			</ThemeSection>
			<ThemeSection name="Small text" icon="h2">
				<H2RInput
						key={`${baseTheme.name}_h2_font`}
						label="Font"
						colour="dark"
						value={baseTheme.h2?.font || baseTheme.font?.family}
						onChange={(change) => {
							onUpdate("h2", "font", change);
						}}
						inputHasOptions={true}
						options={[
							...fonts?.map((font)=>{
								return {
									label: font,
									value: font
								}
							})
						]}
					/>
				<H2RInput
					key={`${baseTheme.name}_h2_colour`}
					label="Colour"
					colour="dark"
					colourPicker={true}
					value={baseTheme.h2?.colour}
					onChange={(change) => {
						onUpdate("h2", "colour", change);
					}}
				/>
				<H2RInput
					key={`${baseTheme.name}_h2_size`}
					type="range"
					label="Size"
					colour="dark"
					value={fontSizeOptions.findIndex((e, i) => {
						if (e.value === baseTheme.h2?.size) return i;
					})}
					labelValue={findThemeLabel(fontSizeOptions, baseTheme.h2?.size)}
					options={fontSizeOptions}
					max={fontSizeOptions.length - 1}
					onChange={(change) => {
						onUpdate("h2", "size", fontSizeOptions[change].value);
					}}
				/>
				<H2RInput
					key={`${baseTheme.name}_h2_leading`}
					type="range"
					label="Line height"
					colour="dark"
					value={leadingOptions.findIndex((e, i) => {
						if (e.value === baseTheme.h2?.leading) return i;
					})}
					labelValue={
						findThemeLabel(leadingOptions, baseTheme.h2?.leading) || "Auto"
					}
					options={leadingOptions}
					max={leadingOptions.length - 1}
					onChange={(change) => {
						onUpdate("h2", "leading", leadingOptions[change].value);
					}}
				/>

				<div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
					<H2RCheckbox
						key={`${baseTheme.name}_h2_bold`}
						randomId={`h2_bold`}
						checkboxLabel="Bold"
						checked={[true, "true"].includes(baseTheme.h2?.bold) ? true : false}
						onChange={(change) => {
							onUpdate("h2", "bold", change);
						}}
					/>
					<H2RCheckbox
						key={`${baseTheme.name}_h2_italic`}
						randomId={`h2_italic`}
						checkboxLabel="Italic"
						checked={
							[true, "true"].includes(baseTheme.h2?.italic) ? true : false
						}
						onChange={(change) => {
							onUpdate("h2", "italic", change);
						}}
					/>
					<H2RCheckbox
						key={`${baseTheme.name}_h2_underline`}
						randomId={`h2_underline`}
						checkboxLabel="Underline"
						checked={
							[true, "true"].includes(baseTheme.h2?.underline) ? true : false
						}
						onChange={(change) => {
							onUpdate("h2", "underline", change);
						}}
					/>
				</div>
			</ThemeSection>
			<ThemeSection name="Background" icon="background">
				<H2RInput
					key={`${baseTheme.name}_background_colour`}
					label="Colour"
					colour="dark"
					colourPicker={true}
					value={baseTheme.background?.colour}
					onChange={(change) => {
						onUpdate("background", "colour", change);
					}}
				/>
				<H2RInput
					key={`${baseTheme.name}_background_colour2`}
					label="Colour 2"
					colour="dark"
					colourPicker={true}
					value={baseTheme.background?.colour2}
					onChange={(change) => {
						onUpdate("background", "colour2", change);
					}}
				/>
				<H2RSelect
					key={`${baseTheme.name}_border_gradient`}
					label="Gradient"
					colour="dark"
					selected={baseTheme.background?.gradient || false}
					options={gradientOptions}
					onChange={(change) => {
						onUpdate("background", "gradient", change);
					}}
				/>
				<H2RInput
					key={`${baseTheme.name}_background_rounding`}
					type="range"
					label="Rounding"
					colour="dark"
					value={roundedOptions.findIndex((e, i) => {
						if (e.value === baseTheme.background?.rounding) return i;
					})}
					labelValue={findThemeLabel(
						roundedOptions,
						baseTheme.background?.rounding
					)}
					options={roundedOptions}
					max={roundedOptions.length - 1}
					onChange={(change) => {
						onUpdate("background", "rounding", roundedOptions[change].value);
					}}
				/>
				<H2RInput
					key={`${baseTheme.name}_background_paddingX`}
					type="range"
					label="Padding Left/Right"
					colour="dark"
					value={paddingOptions.findIndex((e, i) => {
						if (e.value === baseTheme.background?.paddingX) return i;
					})}
					labelValue={baseTheme.background?.paddingX?.replace("s", " ")}
					options={paddingOptions}
					max={paddingOptions.length - 1}
					onChange={(change) => {
						onUpdate("background", "paddingX", paddingOptions[change].value);
					}}
				/>
				<H2RInput
					key={`${baseTheme.name}_background_paddingY`}
					type="range"
					label="Padding Top/Bottom"
					colour="dark"
					value={paddingOptions.findIndex((e, i) => {
						if (e.value === baseTheme.background?.paddingY) return i;
					})}
					labelValue={baseTheme.background?.paddingY?.replace("s", " ")}
					options={paddingOptions}
					max={paddingOptions.length - 1}
					onChange={(change) => {
						onUpdate("background", "paddingY", paddingOptions[change].value);
					}}
				/>
				<H2RInput
					key={`${baseTheme.name}_background_glowBlur`}
					type="range"
					label="Glow"
					colour="dark"
					value={
						thicknessOptions.findIndex((e, i) => {
							if (e.value === baseTheme.background?.glowBlur) return i;
						}) || "0"
					}
					labelValue={baseTheme.background?.glowBlur?.replace("s", " ") || "0"}
					options={thicknessOptions}
					max={thicknessOptions.length - 1}
					onChange={(change) => {
						onUpdate("background", "glowBlur", thicknessOptions[change].value);
					}}
				/>
			</ThemeSection>
			<ThemeSection name="Border" icon="border">
				<div className="flex space-x-4">
					<BorderSelect
						key={`${baseTheme.name}_border_sides`}
						top={baseTheme.border?.sides[0]}
						bottom={baseTheme.border?.sides[1]}
						left={baseTheme.border?.sides[2]}
						right={baseTheme.border?.sides[3]}
						onToggle={(change) => {
							onUpdate("border", "sides", change);
						}}
					/>
					<H2RInput
						key={`${baseTheme.name}_border_colour`}
						label="Colour"
						colour="dark"
						colourPicker={true}
						value={baseTheme.border?.colour}
						onChange={(change) => {
							onUpdate("border", "colour", change);
						}}
					/>
				</div>
				<H2RSelect
					key={`${baseTheme.name}_border_style`}
					label="Style"
					colour="dark"
					selected={baseTheme.border?.style}
					options={borderOptions}
					onChange={(change) => {
						onUpdate("border", "style", change);
					}}
				/>

				<H2RInput
					key={`${baseTheme.name}_border_size`}
					type="range"
					label="Size"
					colour="dark"
					// min={0}
					// min={1}
					// step={0.1}
					value={borderSizeOptions.findIndex((e, i) => {
						if (e.value === baseTheme.border?.size) return i;
					})}
					labelValue={findThemeLabel(borderSizeOptions, baseTheme.border?.size)}
					options={borderSizeOptions}
					max={borderSizeOptions.length - 1}
					onChange={(change) => {
						onUpdate("border", "size", borderSizeOptions[change].value);
					}}
				/>
			</ThemeSection>
			<ThemeSection name="Position" icon="position">
				<H2RInput
					key={`${baseTheme.name}_position_marginX`}
					type="range"
					label="Margin Left/Right"
					colour="dark"
					value={marginOptions.findIndex((e, i) => {
						if (e.value === baseTheme.position?.marginX) return i;
					})}
					labelValue={baseTheme.position?.marginX?.replace("s", " ")}
					options={marginOptions}
					max={marginOptions.length - 1}
					onChange={(change) => {
						onUpdate("position", "marginX", marginOptions[change].value);
					}}
				/>
				<H2RInput
					key={`${baseTheme.name}_position_marginY`}
					type="range"
					label="Margin Top/Bottom"
					colour="dark"
					value={marginOptions.findIndex((e, i) => {
						if (e.value === baseTheme.position?.marginY) return i;
					})}
					labelValue={baseTheme.position?.marginY?.replace("s", " ")}
					options={marginOptions}
					max={marginOptions.length - 1}
					onChange={(change) => {
						onUpdate("position", "marginY", marginOptions[change].value);
					}}
				/>
			</ThemeSection>
			<ThemeSection name="Transition" icon="transition">
				<H2RSelect
					key={`${baseTheme.name}_transition_type`}
					label="Type"
					colour="dark"
					selected={baseTheme.transition?.type}
					options={transitionOptions}
					onChange={(change) => {
						onUpdate("transition", "type", change);
					}}
				/>
				<H2RSelect
					key={`${baseTheme.name}_transition_duration`}
					label="Duration"
					colour="dark"
					selected={baseTheme.transition?.duration}
					options={transitionDurationOptions}
					onChange={(change) => {
						onUpdate("transition", "duration", change);
					}}
				/>
			</ThemeSection>
		</>
	);
}
